export interface ParamsDelay {
  action: () => void;
  cancel: () => void;
  delayInMs?: number;
}

export const delay = (params: ParamsDelay) => {
  const handle = window.setTimeout(() => {
    params.action();
  }, params.delayInMs ?? 750);

  return () => {
    window.clearTimeout(handle);
    params.cancel();
  };
};
